import {
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Utils } from '@serasa/shared/utils/utils';
import { Subscription } from 'rxjs';
import { Labels } from './../../../../../shared/labels';
import { InteractivityService } from '@serasa/shared/services/interactivity.service';
import { SedsModalService } from 'experian-design-system';
import { UserIdleModalComponent } from '@serasa/shared/components/user-idle-modal/user-idle-modal.component';
import { JwtHelperService } from '@auth0/angular-jwt';

@Component({
    selector: 'pl-user-idle',
    template: ``,
    standalone: false
})
export class UserIdleComponent implements OnInit, OnDestroy {

  public labels = new Labels().userIdle.modal;
  public Utils = Utils;

  private readonly _subs: Subscription[] = [];
  private readonly _milisecondsToShowModal = Number.parseInt(localStorage.getItem('milisecondsToShowModal')|| '') || 13 * 60 * 1000;

  constructor(
    private readonly _interactivityService: InteractivityService,
    private readonly _modalService: SedsModalService,
    private readonly _jwtHelper: JwtHelperService,
  ) { }

  ngOnInit() {
    this._verifyInteractivity();
  }

  private _showUserIdleModal(show = true): void {
    const accessToken = Utils.getCookie("accessToken");
    const jwtIsExpired = this._jwtHelper.isTokenExpired(accessToken);

    if (show && !jwtIsExpired) {
      this._openModalUserIdle();
    }

    this._interactivityService.hasModalOpened = true;
  }

  private _verifyInteractivity(): void {
    this._subs.push(this._interactivityService.setupInactivityTimer(this._milisecondsToShowModal).subscribe());
    this._subs.push(this._interactivityService.noInteraction$.subscribe((event) => {
      if (this._interactivityService.hasModalOpened === false) {
        this._showUserIdleModal();
      }
    }));
  }

  private _openModalUserIdle(): void {
    const options = {
      width: '512px',
    };

    this._modalService.open(UserIdleModalComponent, null, options);
  }

  ngOnDestroy() {
    for (const sub of this._subs) {
      sub?.unsubscribe();
    }
  }

}
